import AppBar from "@material-ui/core/AppBar";

const appBar = ({ children, ...otherProps }) => {
  return <AppBar {...otherProps}>{children}</AppBar>;
};

export default appBar;
